import { render, staticRenderFns } from "./newUP.vue?vue&type=template&id=31c01308&"
import script from "./newUP.vue?vue&type=script&lang=js&"
export * from "./newUP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports